<template>
    <div   style="position: relative;width: 100vw;height: 100vh;">
  <v-card  width="80%"  class="white--text" style="max-width: 450px;letter-spacing: 3px;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%)">
    <v-card-title class="mb-5 pt-3 pb-3 title"  style="text-align: center!important; display: block; background-color:#1976d2;letter-spacing: 3px!important;">パスワード変更</v-card-title>
    <div class="pb-7 pr-7 pl-7 "> 
    
    <v-text-field outlined dense class="mb-1" label="登録済メールアドレスを入力" type="text" v-model="mailAddress"></v-text-field>
    
   
     
    
    <v-btn class=" pb-2 pt-2 white--text" @click="confirmAddress" color="red darken-2 ">再設定メールを送信する</v-btn>
     <span class="text-center subtitle-1 mt-2 mb-2">or</span>
      <v-btn class=" pb-2 pt-2 " to="/signin" >ログイン画面に戻る</v-btn>
     </div>
  </v-card>
  
    <div>
      
    </div>
   
  </div>
</template>
<script>
import firebase from 'firebase'
 
export default {
      
    data() {
        return {
       mailAddress: '',
        }
    },
    methods: {
    confirmAddress: function(){
     firebase.auth().sendPasswordResetEmail(this.mailAddress).then(function(){
         alert('メールを送信しました');
     }).catch(function(error){
         alert(error.message);
     })
    },
     
  }
}                                                                                                                                   
</script>
<style scoped>
 input {
  display: block!important;
  border: 1px solid #999;
  width: 100%;
}
span {
  color: #333;
  font-size: 12px;
  display: block;
  
}

.v-btn {
  display: block!important;
  width: 100%;
  height: auto!important;
}
</style>
